import React from 'react';
import { SeeMore } from 'Components/frameworks/see-more/SeeMore';
import type { TextProps } from 'Components/frameworks/text/Text';
import { Text } from 'Components/frameworks/text/Text';
export type TextSeeMoreProps = TextProps & {
  className?: string;
  dataTestIdPrefix?: string;
  hasNoScrollOnCollapse?: boolean;
  isCollapseEnabled?: boolean;
  offsetScrollSelector?: string;
  onClick?: (arg0: React.SyntheticEvent) => void;
  seeMoreColor?: Colors;
  seeLessLabel?: string;
  seeMoreLabel?: string;
  seeMoreSize?: number;
};
export const TextSeeMore = ({
  className,
  dataTestIdPrefix = 'TextSeeMore',
  hasNoScrollOnCollapse,
  isCollapseEnabled,
  offsetScrollSelector,
  onClick,
  seeMoreColor,
  seeLessLabel,
  seeMoreLabel,
  seeMoreSize,
  ...textProps
}: TextSeeMoreProps) => (
  <SeeMore
    className={className}
    color={seeMoreColor}
    hasNoScrollOnCollapse={hasNoScrollOnCollapse}
    isCollapseEnabled={isCollapseEnabled}
    offsetScrollSelector={offsetScrollSelector}
    onClick={onClick}
    seeLessLabel={seeLessLabel}
    seeMoreLabel={seeMoreLabel}
    seeMoreSize={seeMoreSize}
  >
    <Text {...textProps} data-testid={`${dataTestIdPrefix}-text`} />
  </SeeMore>
);
